const server_url = 'https://love-code.herokuapp.com/api';
const client_url = window.location.origin;

module.exports = { server_url, client_url };